import { useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { useActionDispatch } from '../../hooks';
import { BannerListItem } from './BannerListItem';

import type {
  ElemasonBannerListWidget,
  ElemasonBannerListWidgetItemData,
} from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonBannerListWidgetProps {
  widget: ElemasonBannerListWidget;
}

const BannerListWidget: FC<ElemasonBannerListWidgetProps> = ({
  widget: { data, config, actions },
}) => {
  const { items } = data ?? {};
  const { list } = config ?? {};
  const dispatch = useActionDispatch();
  const { style, className } = useStyleConfig(list ?? {});

  const onClick = (item: ElemasonBannerListWidgetItemData) => {
    actions?.onItemClick.forEach((action) => dispatch(action, item));
  };

  if (!items) return null;

  return (
    <div
      className={clsx('flex w-full flex-row overflow-scroll', className)}
      style={style}
    >
      {items.map((item, index) => (
        <BannerListItem
          key={index}
          item={item}
          config={config}
          onClick={actions?.onItemClick?.length ? onClick : undefined}
        />
      ))}
    </div>
  );
};

export { BannerListWidget };
